<template>
  <div id="visitor-editor-modal">
    
    <memlist-modal ref="edit-visitor" :title="local_item.name" size="xl">

      <m-row>
        <m-col lg="6">
          <memlist-text-input
            id="ip"
            name="ip"
            layout="vertical"
            :title="$t('FORM.VISITOR.IP')"
            validation_type="TEXT"
            v-model="local_item.ip"
            :disabled="true"
          />
        </m-col>
      </m-row>
      <m-row>
        <m-col lg="6">
          <memlist-text-input
            id="created_at"
            name="created_at"
            layout="vertical"
            :title="$t('FORM.VISITOR.FIRST_CREATED_AT')"
            validation_type="TEXT"
            v-model="format_created_at"
            :disabled="true"
          />

        </m-col>
      </m-row>

      <m-row>
        <m-col lg="12">
          <memlist-text-input
            id="user_agent"
            name="user_agent"
            layout="vertical"
            :title="$t('FORM.VISITOR.USER_AGENT')"
            validation_type="TEXT"
            v-model="local_item.user_agent"
            :disabled="true"
          />

        </m-col>
      </m-row>
      
      
      
      <m-row>
        <m-col lg="12">
          <RightModalSaveAndCloseButtons
            class="mt-4"
            :text="$t('COMMON.SAVE')"
            :spin="true"
            @clicked="save_ticket_clicked"
            @close="$refs['edit-ticket'].hide()"
            ref="saveButton"
          />
        </m-col>
      </m-row>
      
    </memlist-modal>

  </div>
</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import dayjs from 'dayjs';

export default {
  name: 'EventTypeEditorModal',
  components: {
    
  },
  mixins: [ toasts ],
  computed: {

    format_created_at() {
      return dayjs(this.local_item.created_at).format('YYYY-MM-DD HH:mm');
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages', 'companies']),
    
  },
  props: ['id'],
  watch: {
    currentCompanyId() {
      
    },
    id() {
      if (this.id) {
        this.fetch_visitor(this.id);
      }
    }
  },
  emits: ['created', 'updated', 'deleted'],
  async mounted() {
    
  },
  methods: {
    
    async fetch_visitor(id) {
      const res = await axios.get(`/form/visitor/${id}`);
      
      if (res.status !== 200) {
        return false;
      }

      this.local_item = res.data;
    },


    show() {
      this.$refs['edit-visitor'].show();
    },

    async save_vistior_clicked() {
      if (this.local_item.id) {
        await this.put_visitor(this.local_item);
      }
      else {
        await this.post_visitor(this.local_item);
      }

      this.$refs['saveButton'].stop();
    },


    async put_visitor(item) {
      try {
        const res = await axios.put(`/events/tickets/${item.id}`, item);

        if (res.status === 204) {
          this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('EVENT.TICKET.UPDATED'));

          this.$emit('updated', item);

          return;
        }

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_UPDATE'));
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_UPDATE'));
      }
    },

    async post_visitor(item) {
      try {

        return false;
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.TICKET.UNABLE_CREATE'));
      }
    },

    reset() {
      this.local_item = {
        
      };

    }
  },
  data() {
    return {
      
      local_item: {
        
      }
    };
  },
  
};
</script>
<style lang="scss" scoped>

.m-row { margin-top: 16px; }

</style>